import {
  FeatureName,
  PermissionValues as Permissions,
} from '@gripp/shared-logic';
import { ImpersonationUserColumn } from '../impersonation/components/impersonationUserColumn';
import { ImpersonationWorkspaceColumn } from '../impersonation/components/impersonationWorkspaceColumn';
import { ImpersonationWorkspaceFiltersColumn } from '../impersonation/components/impersonationWorkspaceFiltersColumn';
import { SettingsApiKey } from './components/components/settingsApiKey';
import { SettingsAppearance } from './components/components/settingsAppearance';
import { SettingsCommunication } from './components/components/settingsCommunication';
import { SettingsPreferences } from './components/components/settingsPreferences';
import { SettingsProfile } from './components/components/settingsProfile';
import { Settings } from './components/settings';

export const settingsPaths = {
  root: 'settings',
};

export const settingsRoutes = [
  {
    path: settingsPaths.root,
    element: <Settings />,
    handle: {
      header: {
        titleKey: 'Settings',
        icon: 'cog-outline',
      },
    },
    children: [
      {
        path: 'profile',
        element: <SettingsProfile />,
      },
      {
        path: 'notifications',
        element: <SettingsPreferences />,
      },
      {
        path: 'appearance',
        element: <SettingsAppearance />,
        handle: {
          requiredFeature: FeatureName.Appearance,
        },
      },
      {
        path: 'api',
        element: <SettingsApiKey />,
        handle: {
          requiredPermission: Permissions.globalAdmin,
        },
      },
      {
        path: 'communication',
        element: <SettingsCommunication />,
        handle: {
          requiredPermission: Permissions.globalAdmin,
          requiredFeature: FeatureName.CommunicationPlatform,
        },
      },
      {
        path: 'impersonation/workspace',
        element: <ImpersonationWorkspaceColumn />,
        handle: {
          requiredPermission: Permissions.globalAdmin,
        },
      },
      {
        path: 'impersonation/workspace/filters',
        element: <ImpersonationWorkspaceFiltersColumn />,
        handle: {
          requiredPermission: Permissions.globalAdmin,
        },
      },
      {
        path: 'impersonation/user',
        element: <ImpersonationUserColumn />,
        handle: {
          requiredPermission: Permissions.globalAdmin,
        },
      },
    ],
  },
];
